import type { AnyObj } from '@blockworks/platform';
import { useTrack } from '@blockworks/platform/services';
import { FlexBox, type FlexBoxProps, Link, Text } from '@blockworks/ui';
import { cn } from '@blockworks/ui/system';

import { AnalyticsEvent } from '../../utils/events-tracking';

const RESEARCH_URL = 'https://app.blockworksresearch.com';
const makeUrl = (route: string) => `${RESEARCH_URL}/${route}?callback=${window.location.href}`;

type SubscribeToAccessProps = FlexBoxProps & {
    trackEvent?: {
        event:
            | AnalyticsEvent.SubscribeToExpandClicked
            | AnalyticsEvent.SubscribeToExportClicked
            | AnalyticsEvent.SubscribeToShareClicked;
        data?: AnyObj;
    };
};

const SubscribeToAccess = ({ children, className, trackEvent, ...rest }: SubscribeToAccessProps) => {
    const track = useTrack();
    const handleTrack = () => {
        if (trackEvent) {
            const { event, data } = trackEvent;
            track?.(`${event}`, data);
        }
    };
    return (
        <FlexBox
            col
            alignItems="start"
            justifyContent="center"
            gap="lg"
            p={4}
            className={cn('w-[220px]', className)}
            {...rest}
        >
            <Text size="xs">{children}</Text>
            <FlexBox gap={3} alignItems="center">
                <Link
                    target="_blank"
                    borderRadius="sm"
                    size="xs"
                    intent="primary"
                    variant="fill"
                    textTransform="uppercase"
                    href={makeUrl('sign-up')}
                    onClick={handleTrack}
                >
                    Sign Up
                </Link>
                <Link
                    target="_blank"
                    size="xs"
                    intent="primary"
                    variant="underline"
                    textTransform="uppercase"
                    href={makeUrl('sign-in')}
                >
                    Log In
                </Link>
            </FlexBox>
        </FlexBox>
    );
};

export { SubscribeToAccess };
